import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/_public/it-partner-quotes_/$quoteId_/pdf')({
  staticData: { team: 'fe-clm' },
});
